import React from 'react'

const UnsubscribeSuccessfulScreen = () => {
  return (
    <div className="bg-bgColor h-screen">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            <h1 className='text-3xl font-extrabold tracking-tight text-gray-800 mb-8 text-center '>
                You have been successfully unsubscribed. Please allow up to 24 hours for any changes to take effect.
            </h1>
        </div>
     </div>
  )
}

export default UnsubscribeSuccessfulScreen